import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';

function PopupNav({ indexClass }) {
  return (
    <div className={'flexRow center popupv2-nav-container'}>
      <div className={`popupv2-nav ${indexClass === 'firstTip' && 'selected'}`} />
      <div className={`popupv2-nav ${indexClass === 'secondTip' && 'selected'}`} />
      <div className={`popupv2-nav ${indexClass === 'thirdTip' && 'selected'}`} />
    </div>
  )
}

PopupNav.propTypes = {
  indexClass: PropTypes.string.isRequired
}

export default PopupNav;
